/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STQueryEditorApi {
  async StringifyQuery(query : st.STQuery) : Promise<string> {
    return await componentApi.call('st', 'st-query-editor', 'STQueryEditorApi', 'StringifyQuery', {
      query,
    });
  }
  async ParseQuery(query : string) : Promise<st.STQuery> {
    return await componentApi.call('st', 'st-query-editor', 'STQueryEditorApi', 'ParseQuery', {
      query,
    });
  }
  async LoadProperties(boid : string, excludeMethodBound : boolean) : Promise<Array<st.BOPropertyInfo>> {
    return await componentApi.call('st', 'st-query-editor', 'STQueryEditorApi', 'LoadProperties', {
      boid,
      excludeMethodBound,
    });
  }
}
export default new STQueryEditorApi()
